import { render, staticRenderFns } from "./ModuleRootView.vue?vue&type=template&id=604a67d7"
import script from "./ModuleRootView.vue?vue&type=script&lang=js"
export * from "./ModuleRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports